/* Thin wrapper around fetch with auth header + JSON parsing. */

/**
 * Resolve the API origin for browser requests.
 * Prefers REACT_APP_BACKEND_URL; falls back to api.premierlab.ai for
 * non-local hosts (production + Cloudflare preview) so relative /api
 * calls never hit the pages.dev frontend origin.
 */
export function resolveApiBase({
  envUrl = process.env.REACT_APP_BACKEND_URL,
  hostname =
    typeof window !== "undefined"
      ? window.location.hostname
      : "",
} = {}) {
  const configured = String(envUrl || "").trim();

  if (configured) {
    return configured.replace(/\/+$/, "");
  }

  const normalizedHost = String(hostname || "").toLowerCase();
  const isLocal =
    normalizedHost === "localhost" ||
    normalizedHost === "127.0.0.1" ||
    normalizedHost === "::1";

  if (isLocal || !normalizedHost) {
    return "";
  }

  return "https://api.premierlab.ai";
}

const BASE = resolveApiBase();

function token() {
  return localStorage.getItem("pl_token");
}

async function request(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token() ? { Authorization: `Bearer ${token()}` } : {}),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data;
  try { data = text ? JSON.parse(text) : null; } catch (_) { data = text; }
  if (!res.ok) {
    const err = new Error((data && data.detail) || res.statusText || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

async function upload(path, formData) {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: {
      ...(token() ? { Authorization: `Bearer ${token()}` } : {}),
    },
    body: formData,
  });
  const text = await res.text();
  let data;
  try { data = text ? JSON.parse(text) : null; } catch (_) { data = text; }
  if (!res.ok) {
    const err = new Error((data && data.detail) || res.statusText || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const api = {
  get:    (p)     => request("GET",    p),
  post:   (p, b)  => request("POST",   p, b),
  patch:  (p, b)  => request("PATCH",  p, b),
  del:    (p)     => request("DELETE", p),
  upload,
  token,
  setToken: (t) => t ? localStorage.setItem("pl_token", t) : localStorage.removeItem("pl_token"),
};
